<template>
  <v-col cols="12" md="7" lg="8" class="pt-2">
    <slot></slot>
  </v-col>
</template>

<script>
export default {}
</script>
